import { connect } from 'react-redux'
import { compose, withStateHandlers } from 'recompose'
import { selectEditableLoanBalance } from 'src/store/selectors/home/loans'

const EditBalanceContainer = compose(
  connect(
    state => ({ value: selectEditableLoanBalance(state) }),
    dispatch => ({})
  ),
  withStateHandlers(
    ({ value = '' }) => ({ value, shouldShowInterstitial: !value }),
    { hideInterstitial: () => () => ({ shouldShowInterstitial: false }) }
  )
)

export default EditBalanceContainer
